import { render } from "./CompanyEdit.vue?vue&type=template&id=6f9c1834"
import script from "./CompanyEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyEdit.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/modules/company/components/CompanyEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6f9c1834"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6f9c1834', __exports__)) {
    api.reload('6f9c1834', __exports__)
  }
  
  module.hot.accept("./CompanyEdit.vue?vue&type=template&id=6f9c1834", () => {
    api.rerender('6f9c1834', render)
  })

}


export default __exports__